import { Component, Input } from '@angular/core';

import { FeedSubjectCarouselComponent } from '../../feed-subject-carousel/feed-subject-carousel.component';
import { NewUiLayoutComponent } from '../new-ui-layout/new-ui-layout.component';

@Component({
    selector: 'app-feed-subject-card',
    templateUrl: './feed-subject-card.component.html',
    styleUrls: ['./feed-subject-card.component.scss'],
    imports: [FeedSubjectCarouselComponent, NewUiLayoutComponent]
})
export class FeedSubjectCardComponent {
    @Input() card;
    @Input() timeline_id;
    
    constructor() { }
}
